import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import Axios from "axios";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Skeleton from "@material-ui/lab/Skeleton";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";

import MoreVertIcon from "@material-ui/icons/MoreVert";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import InfoIcon from "@material-ui/icons/Info";

import RentIcon from "../../../../Assets/Logo/RentIcon.svg";
import BuyIcon from "../../../../Assets/Logo/NepalCurrencyIcon.svg";
import { url } from "../../../../config/config";
import { useStyles } from "./BookItem.css";
import { withRouter } from "react-router";

class BookItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      soldBooks: [],
      speedDialOpen: false,
      actions: [
        {
          icon: <ShoppingCartIcon style={{ color: "#0a1f3a" }} />,
          name: "Add To Cart",
          clickUrl: () => this.props.handleCart(this.props.book._id),
        },
        {
          icon: (
            <img src={RentIcon} alt="Rent" style={{ width: 30, height: 30 }} />
          ),
          name: "Rent Book",
          clickUrl: () =>
            this.props.history.push(`/book/rent/${this.props.book._id}`),
        },
        {
          icon: (
            <img src={BuyIcon} alt="Buy" style={{ width: 30, height: 30 }} />
          ),
          name: "Buy Book",
          clickUrl: () => this.props.handleBuyBook(this.props.book._id),
        },
        {
          icon: <InfoIcon style={{ color: "#0a1f3a" }} />,
          name: "Book Details",
          clickUrl: () => this.props.handleBook(this.props.book._id),
        },
      ],
    };
  }

  componentDidMount() {
    if (this.props.isAuth) {
      this.getSoldBooks(this.props.userToken);
    }
  }

  getSoldBooks = async (userToken) => {
    const response = await Axios.get(`${url}/api/sold/mybooks`, {
      headers: {
        "x-auth-token": userToken,
      },
    });
    if (response.data.length !== 0) {
      response.data.map((data) =>
        data.itemDetails.map((item) =>
          this.setState({
            soldBooks: [...this.state.soldBooks, { bookId: item.bookId }],
          })
        )
      );
    }
  };

  checkExist = (bookId) => {
    return this.state.soldBooks.findIndex((book) => book.bookId === bookId);
  };

  handleClose = () => {
    this.setState({ speedDialOpen: false });
  };

  handleOpen = () => {
    this.setState({ speedDialOpen: true });
  };

  render() {
    const { classes, book } = this.props;
    return (
      <Grid
        item
        xs={12}
        sm={6}
        md={6}
        xl={4}
        lg={4}
        className={classes.gridItemRoot}
      >
        <Paper className={classes.paper} elevation={5}>
          <div
            className={classes.bookCoverStyle}
            onClick={() => this.props.handleBook(book._id)}
          >
            {book.bookCoverUrl ? (
              <img
                src={book.bookCoverUrl}
                alt="BookCoverImage"
                className={classes.coverImageStyle}
              />
            ) : (
              <Skeleton variant="rect" className={classes.coverImageStyle} />
            )}
          </div>
          <div className={classes.bookBody}>
            <div>
              <div style={{ fontSize: 24, fontWeight: "bold" }}>
                {book.title}
              </div>
              {book.author.firstName && book.author.lastName ? (
                <div style={{ fontSize: 20, color: "grey" }}>
                  By {book.author.firstName} {book.author.lastName}
                </div>
              ) : (
                <Skeleton variant="text" />
              )}
              {book.price ? (
                <div
                  style={{ fontSize: 18, color: "#0a1f3a", fontWeight: "bold" }}
                >
                  Rs.{book.price}
                </div>
              ) : (
                <Skeleton variant="text" />
              )}
            </div>
            <div className={classes.buttonItem}>
              {this.checkExist(book._id) === -1 ? (
                <SpeedDial
                  ariaLabel="SpeedDial example"
                  hidden={false}
                  icon={<SpeedDialIcon icon={<MoreVertIcon />} />}
                  onClose={this.handleClose}
                  onOpen={this.handleOpen}
                  open={this.state.speedDialOpen}
                  direction="left"
                  classes={{ fab: classes.fabRoot }}
                >
                  {this.state.actions.map((action) => (
                    <SpeedDialAction
                      key={action.name}
                      icon={action.icon}
                      tooltipTitle={action.name}
                      tooltipPlacement="bottom-end"
                      onClick={action.clickUrl}
                    />
                  ))}
                </SpeedDial>
              ) : (
                <div
                  style={{
                    padding: 15,
                    fontSize: 18,
                    textAlign: "center",
                    color: "#0a1f3a",
                  }}
                >
                  Already bought
                </div>
              )}
            </div>
          </div>
        </Paper>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.token,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(BookItem)));
